import React, { useEffect, useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../../Kryzen Alpha App/Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcClapperboard, FcCompactCamera, FcFilmReel } from "react-icons/fc";
import SimpleButton from "../../../Components/layouts/simple_button";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";

const ViewInformativeVideos = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/informative-video/view/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting podcasts!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  const linkifyText = (text) => {
    if (!text) return "N/A";

    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcFilmReel className="fs-2 me-1" />
                  Informative Video
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Informative Video</h2>
            </div>

            <div className="card-body">
              {!data ? (
                <div className="text-center text-muted">No data found</div>
              ) : (
                <>
                  <h3>Planning Informative Video </h3>
                  <hr></hr>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Branding Assets
                    </label>
                    <div className="w-100 col">
                      {data?.videoBranding || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Video Language{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.videoLanguage || "N/A"}
                    </div>
                  </div>
                  <hr></hr>
                  <h3>Video Shooting </h3>
                  <hr></hr>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Video Venue{" "}
                    </label>
                    <div className="w-100 col">{data?.videoVenue || "N/A"}</div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Shooting Date{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.shootingDate || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Camera / Lens Name{" "}
                    </label>
                    <div className="w-100 col">{data?.cameraName || "N/A"}</div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Raw Footage Folder Path{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.rawFootagePath || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Video Credit{" "}
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.videoCredit) || "N/A"}
                    </div>
                  </div>

                  <hr></hr>
                  <h3>Video Editing </h3>
                  <hr></hr>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Editor Name{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.videoEditor || "N/A"}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Comming Soon Poster
                    </label>
                    <div className="w-100 col">
                      {data?.commingSoonPoster ? (
                        <LazyImageComponent
                          width="40%"
                          src={data?.commingSoonPoster}
                          alt="Comming Soon Poster"
                          // className="rounded"
                        />
                      ) : (
                        "Comming Soon Poster"
                      )}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Video Thumbnail
                    </label>
                    <div className="w-100 col">
                      {data?.videoThumbnail ? (
                        <LazyImageComponent
                          width="40%"
                          src={data?.videoThumbnail}
                          alt="Video Thumbnail"
                          // className="rounded"
                        />
                      ) : (
                        "Video Thumbnaile Not Available"
                      )}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Video First Draft File Path{" "}
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.videofirstPath) || "N/A"}
                    </div>
                  </div>

                  <hr></hr>
                  <h3>Final </h3>
                  <hr></hr>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Final Footage Path
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data.videoDriveLink)}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Video Publish Title{" "}
                    </label>
                    <div className="w-100 col">{data?.videoTitle || "N/A"}</div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Mark as Published (Upload proof)
                    </label>
                    <div className="w-100 col">
                      {data?.markAsPublished ? (
                        <LazyImageComponent
                          width="40%"
                          src={data?.markAsPublished}
                          alt="  Mark as Published "
                          // className="rounded"
                        />
                      ) : (
                        "  Mark as Published  Not Available"
                      )}
                    </div>
                  </div>

                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <SimpleButton
                        buttonText="Edit Informative Video"
                        href={`/edit-informative-video/${id}`}
                      />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewInformativeVideos;
